import { Grid, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Header } from "../0_layout/HeaderFooter";
import { Footer } from "../0_layout/Footer";
import { DzCourseHeader } from "../1_home/DZ_Heading";

export default function AboutUsHome() {

  const [about, setAbout] = useState("SuperTeacher Edureforms Pvt Ltd is a team of seasoned academicians and educators, united under the belief that there should be no hard line between academic skills and real-life skills. SuperTeacher Team is dedicated to provide educational services and support aligned to 21st-century requirements. It leaves no stone unturned to create the best possible experience and value for their clients. As a result, SuperTeacher Edureforms has successfully conducted high-quality training for their clients, who are teachers and students from more than 550 schools from India, South-East Asia, Africa, North America and the Middle East.\n\n It was founded under the core principles of competency-based learning and interdisciplinary approach in coding, physical computing and STEM / STEAM education. SuperTeacher is backed by a well-designed curriculum, scientific assessment framework and a team of talented academicians and trainers.\n\n Super Teacher Edureforms Pvt Ltd has trained over 20,000 students on Computer Programming, Development, Artificial Intelligence, Robotics and Drone Technology : and the count is still growing!");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/about`);
        const data = await response.json();
        setAbout(a => data[0]?.description || a);// <-- Using setAbout, removes the warning
      } catch (error) {
        console.log("Error fetching data:", error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Box><Header></Header></Box>
      <Box bgcolor={'#f5f5f5'}>
        <Box sx={{ mx: { xs: "3%", md: "8%" }, py: '20px', marginTop: { xs: '100px', md: '150px' } }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item xs={12} md={8} sx={{ px: { xs: 2, md: 5 } }}>
              <DzCourseHeader text="ABOUT US" />

              <Grid container direction="column" justifyContent="center" alignItems="center">

                <Box sx={{
                  FontFamily: 'Roboto',
                  fontSize: '14px',
                  color: '#424242',
                  textAlign: 'justify',
                  mb: 2
                }}> {about} </Box>

              </Grid>
            </Grid>

            <Grid item xs={12} md={4}>
              <Grid container direction="row" alignItems="center" sx={{ justifyContent: { xs: "center", md: "end" } }}>
                <Grid>
                  <Box
                    component="img"
                    sx={{ height: 255 }}
                    src="aboutus.png"
                    alt="About Us Image"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box><Footer></Footer></Box>
    </>
  );
}
